import React, { useState, useEffect } from "react";
import SecondaryBtn from "../button/SecondaryBtn";
import Addform from "./SubscribeTabpages/Addform";
import CompleteSingle from "./SubscribeTabpages/CompleteSingle";
import Addsubscribeform from "./SubscribeTabpages/Addsubscribeform";
import { useLocation } from "react-router-dom";
import CompleteSubscribe from "./SubscribeTabpages/CompleteSubscribe";

const steps = [
  { id: 0, label: "STEP 1" },
  { id: 1, label: "STEP 2" },
];

const SubscribeTab = () => {
  const location = useLocation();
  const orderType = location.state?.orderType || "single"; 
  const [tab, setTab] = useState(0); 
  const [planType, setPlanType] = useState("weekly"); 
  useEffect(() => {
    localStorage.setItem("subscribe_tab", tab);
  }, [tab]);

  return (
    <>
      {/* STEPPER */}
      <div className="flex items-center justify-center mt-2 md:mt-8 ">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center">
              <button
                onClick={() => setTab(index)}
                className={`h-10 w-10 rounded-full flex items-center justify-center text-sm font-semibold
                transition-all
                ${
                  tab === index
                    ? "bg-[#FF6943] text-white"
                    : tab > index
                      ? "bg-green-500 text-white"
                      : "bg-white border border-gray-300 text-gray-500"
                }`}
              >
                {String(index + 1).padStart(2, "0")}
              </button>
            </div>

            {index !== steps.length - 1 && (
              <div className="relative mx-3 w-28">
                <span
                  className={`absolute -top-5 left-1/2 -translate-x-1/2 text-xs font-medium
                  ${tab === index ? "text-gray-900" : "text-gray-400"}`}
                >
                  {step.label}
                </span>

                <div
                  className={`h-[2px] w-full transition-all
                  ${tab > index ? "bg-green-500" : "bg-gray-300"}`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* STEP CONTENT */}
      {tab === 0 && (
        <div>
          <h1 className="text-sm mt-2 font-semibold text-center">
            Meal & Plan Details
          </h1>
          <div className="mt-8">
            {orderType === "subscription" ? (
              <Addsubscribeform planType={planType} setPlanType={setPlanType} setTab={setTab} />
            ) : (
              <Addform setTab={setTab} />
            )}
          </div>
        </div>
      )}

      {tab === 1 && (
        <div>
          <h1 className="text-sm mt-2 font-semibold text-center">
            Complete Your Order
          </h1>
          <div className="mt-8">
            {orderType === "subscription" ? (
              <CompleteSubscribe planType={planType} />
            ) : (
              <CompleteSingle />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SubscribeTab;
